import axios from "axios";

export default function PurchaseorderDeleteService(id) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/purchase_order/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
